import React, { useState, useEffect, Component } from "react";
import { Button, Form, FormGroup, Label, Input } from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { reactLocalStorage } from "reactjs-localstorage";
import axios from "axios";

// import { withRouter } from "react-router-dom";
// import { Alert } from "bootstrap/dist/js/bootstrap.bundle";

import { apiKeyHeader } from "../../../configs/ApiKeys";
import { WsPutCostSheet } from "../../../configs/WebService";
import userStore from "../../../zustand/userStore";

// import withRouter from "../WithRouter";
const AddItemProductForCostingForm = (props) => {
  // const orgId=1;//Testing
  // const userId=1;//Testing
  const userData = userStore((state) => state.user);
  console.log("AddItemProductForCostingForm_props", props);
  const navigate = useNavigate();
  const location = useLocation();
  // const userData = reactLocalStorage.getObject("cs_user_data");

  const [title, setTitle] = useState(props.costingSheet.title);

  const [code, setCode] = useState(props.costingSheet.code);

  const [detail, setDetail] = useState(props.costingSheet.detail);

  const [errorMsg, setErrorMsg] = useState("");

  let masterItem = {
    title: "BOQ",
    code: "boq_bom",
    price: 0,
  };

  // changeHandler = (e) => {
  //   this.setState({ [e.target.name]: e.target.value });
  // };

  const onSubmitHandler = (e) => {
    e.preventDefault();
    createCostSheetProcess();
  };

  function createCostSheetProcess() {
    // toast.success("Submitting ...", { position: "bottom-center" });
    //DveNote:new WS : create or update costsheet
    let formJsonParams = JSON.stringify({
      //insert
      // orgId: userData.org.id,
      userId: userData.id,
      title: title,
      detail: detail,
    });

    if (props.action.toLowerCase() === "edit") {
      formJsonParams = JSON.stringify({
        //update
        // orgId: userData.org.id,
        userId: userData.id,
        id: props.costingSheet.id,
        title: title,
        detail: detail,
      });
    }
    // console.log("createCostSheetProcess_WebService", WebService);
    console.log("createCostSheetProcess_formJsonParams", formJsonParams);
    axios
      .post(WsPutCostSheet, formJsonParams, {
        headers: apiKeyHeader(),
      })
      .then((response) => {
        console.log("response", response.data);
        const responseData = response.data;
        if (responseData.resultCode == 1) {
          // const itemData = responseData.result_message
          // console.log("Item Data", itemData);
          //   toast.success(responseData.result_message, {
          //     position: "top-center",
          //   });
          // this.goToShowUserPage();
          goToAddCostingSheetItems({
            //create_user
            id: responseData.resultMessage.costSheetId,
            title: title,
            detail: detail,
          });
        } else {
          alert(responseData.resultMessage);
        }
      })
      .catch((error) => {
        console.error("error", error);
        // this.setState({ errorMsg:  });
        setErrorMsg("Error while getting data");
      });
  }

  function goToShowUserPage() {
    // console.log("gotopage")
    navigate("/showallipcosting");
  }

  function goToAddCostingSheetItems(costingSheet) {
    console.log("costingSheet", costingSheet);
    delete costingSheet["actiontd"]; //Bug(If Not Using): Point To Be Notted
    // navigate("/costingMasters", {
    //   state: { costingSheet: costingSheet },
    // });
    navigate("/costingAddItems", {
      state: {
        masterItem: masterItem,
        costingSheet: costingSheet,
        type: "forMasterItem",
      },
    });
  }

  // render() {
  // const { productTitle, code, productDetail, errorMsg } = this.state;
  return (
    <div>
      <Form className="px-3 py-2" onSubmit={onSubmitHandler} method="POST">
        <FormGroup className="mb-3">
          <Label for="exampleEmail">Title</Label>
          <Input
            type="text"
            name="title"
            id="title"
            placeholder="Costsheet title"
            value={title}
            onChange={(e) => {
              setTitle(e.target.value);
            }}
            required
          />
        </FormGroup>
        <FormGroup className="mb-3">
          <Label for="exampleEmail">Detail</Label>
          <Input
            type="text"
            name="detail"
            id="detail"
            placeholder="Detail"
            value={detail}
            onChange={(e) => {
              setDetail(e.target.value);
            }}
            required
          />
        </FormGroup>
        <Button className="mb-3" type="submit">
          Submit
        </Button>
        <Button
          className="mx-2 mb-3"
          type="button"
          onClick={(e) => {
            e.preventDefault();
            navigate(-1);
          }}
        >
          Cancel
        </Button>
        {/* {(() => {
              if (this.state.userData.isAdmin == true) {
                return (
                );
              } else {
                return (<></>);
              }
          })()} */}
      </Form>
      {errorMsg ? <div>{errorMsg}</div> : null}
    </div>
  );
  // }
};

// export default withRouter(AddItemProductForCostingForm);
export default AddItemProductForCostingForm;
